import { IPropTypes as ICarrierItemProps } from 'features/shipping/components/ShippingCarrierItem/ShippingCarrierItem.types';

export type IPropTypes = Pick<ICarrierItemProps, 'carrier'>;

export enum ActiveModalKey {
    carrierServices = 'carrierServices',
    connectFedex = 'connectFedex',
}
